module.exports = __webpack_public_path__ + "static/east-c77311bfad8c66c45f341159f68f2b86.jpg";